import styled from 'styled-components'

import '@fontsource/plus-jakarta-sans'

export const ContainerInitialForm = styled.div`
  width: 100%;
  background-image: url('/assets/icons/Copia-DIGA-AH-1.svg');
`

export const InitialFormContent = styled.div<{ $isLogged: boolean }>`
  width: 100%;
  padding: ${({ $isLogged }) => ($isLogged ? '0' : '32px')};
  background: #f6f6f6;

  @media screen and (max-width: 768px) {
    padding: 10px;
    overflow-y: scroll;
    max-height: calc(100vh - 200px);
  }
`
export const DescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 190px;
  border-radius: 10px;
  border: 0.5px solid #08a8d2;
  box-shadow: 0px 4px 8px 0px rgba(142, 146, 188, 0.05);
  margin-bottom: 50px;

  .description {
    color: #0a0a18;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: -0.4px;
    max-width: 900px;
  }

  @media screen and (max-width: 768px) {
    padding: 10px;
    margin-bottom: 30px;

    .description {
      font-size: 15px;
    }
  }
`
export const FormContainer = styled.div`
  padding: 0 8px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  max-height: calc(100vh - 137px);
  background-color: #fdfdfd;
  border-radius: 10px;

  @media screen and (max-width: 768px) {
    margin-bottom: 40px;
    overflow-y: unset;
    max-height: fit-content;
    padding-bottom: 20px;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px rgba(142, 146, 188, 0.05);
  width: 100%;
  max-width: 900px;
  gap: 20px;

  .initial-form-title {
    width: 100%;
  }

  .button-save {
    display: flex;
    justify-content: center;
    width: 180px;
    height: 40px;
  }

  @media screen and (max-width: 768px) {
    padding: 10px 15px;

    .initial-form-title {
      margin-top: 20px;
      font-size: 16px;
    }
  }
`

export const QuestionWithAnswers = styled.div`
  display: grid;
  grid-template-columns: 24px calc(100% - 35px);
  grid-template-rows: (2, 1fr) 1fr;
  column-gap: 8px;
  row-gap: 10px;
  width: 100%;
  margin-bottom: 20px;

  p {
    color: #0a0a18;
    text-align: justify;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    /* letter-spacing: -0.36px; */
  }

  .number {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #08aad21f;
    border: solid 1px #08a8d2;
    border-radius: 50%;
    font-size: 14px;
    color: #089dc2;
    font-weight: 600;
  }
  .question {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    min-height: 24px;
  }

  .textarea-answer {
    grid-column: span 2 / span 2;
  }

  .response {
    grid-column: span 2 / span 2;
    padding: 5px 10px 10px 10px;
    background-color: #f6f6f6;
    border-radius: 10px;
    white-space: pre-wrap;
  }
`
